import { render, staticRenderFns } from "./DepositFailModal.vue?vue&type=template&id=7ce383fc&scoped=true"
import script from "./DepositFailModal.vue?vue&type=script&lang=js"
export * from "./DepositFailModal.vue?vue&type=script&lang=js"
import style0 from "./DepositFailModal.vue?vue&type=style&index=0&id=7ce383fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce383fc",
  null
  
)

export default component.exports